<template>
    <div class="foot">
        <div class="foot_wrap">
            <div class="foot_headwrap">
            <p>版权所有：{{ siteCopyright }}</p>
            <p>技术支持：{{ technicalSupport }}</p>
            <p @click="recordBtn()" style="cursor: pointer;">京ICP备{{icpCode}}</p>
             <div class="footer-box" @click="goHzzz()" style="cursor: pointer;" v-if="publicSecurityCode.length>0"><img src="./../../../assets/images/公安logo.png" style="width: 16px;height: 16px; margin-right: 5px;"/><p > 京公网安备：{{publicSecurityCode}}</p></div>
            </div>
        </div>
    </div>
</template>
<script>
import {websiteInfo} from "@/api/admin";
export default {
    name: "foot",
    data() {
        return {
            siteCopyright:'',//网站版权
            technicalSupport:'',//技术支持
            icpCode:'',//京ICP备
            publicSecurityCode:'',// 公安网安备案
            publicSecurityUrl:'',//icp备案链接
            icpUrl:'',//
        };
    },
    created(){
       this.getWebsite()
    },
    methods:{
       	getWebsite(){//获取站点设置
			    websiteInfo({}).then(res=>{
                    console.log(res,"获取站点设置")
                    this.technicalSupport= res.data.technicalSupport  //技术支持
                    this.siteCopyright=res.data.siteCopyright  //网站版权
                    this.icpCode= res.data.icpCode  //京ICP备
                    this.publicSecurityCode=res.data.publicSecurityCode  //公安网安备案
                    this.publicSecurityUrl=res.data.publicSecurityUrl  //icp备案链接
                    this.icpUrl=res.data.icpUrl  //icp备案链接
			    })
			},
            recordBtn(){
                window.open(this.icpUrl, '_blank');
            },
            goHzzz(){
             window.open(this.publicSecurityUrl, '_blank');
            },
    },
};
</script>

<style lang="scss" scoped>
.foot {
    height: 60px;
    background: rgba(0,0,0,0.7);
    // background: #2d2d2d;
    // padding: 10px;
    // position: fixed;
    // left: 0; 
    // right: 0;
    //  bottom: 0; 
    .foot_wrap {
        font-weight: 400;
        // color: #fff;
        color: rgba(255,255,255,0.8);
        font-size: 14px;
        display: flex;
        flex-direction: column;
       justify-content: center;
       align-content: center;
        width: 1200px;
        margin: 0 auto;
        height: 100%;
        // opacity: 0.6;
        .foot_headwrap{
            display: flex;
            flex-direction: row;
           justify-content: space-between;
           .footer-box{
              display: flex;
              flex-direction: row;
              align-content: center;
           }
        }
        .foot_top{
            margin-top: 8px;
        }
    }
}
</style>
